export enum AppOrigin {
  Production = "https://mem.ai",
}

export const APP_CONFIG = {
  URLS: {
    LANDING_PAGE: "https://get.mem.ai",
    PRODUCT_UPDATES: "https://get.mem.ai/product-updates",
    FAQ: "https://get.mem.ai/faq",
    HELP_AND_SUPPORT: "https://help.mem.ai",
    YOUTUBE: "https://mem.ai/youtube",
    ZAPIER_INTEGRATION: "https://api.mem.ai/api/v2/integrations/zapier/connect",
    ZAPIER_VIDEO_YOUTUBE_URL: "https://www.youtube.com/watch?v=Z9m6BYqTY7A",
    ZAPIER_VIDEO_ASSET_URL:
      "https://storage.googleapis.com/public-mem-assets/videos/automate-your-meeting-notes-with-ai-zapier.mp4",
    INTRO_VIDEO_ASSET_URL:
      "https://storage.googleapis.com/public-mem-assets/videos/welcome-to-mem-thought-partner-onboarding.mp4",
    FEATURE_REQUESTS: "https://support.mem.ai/share-feedback/",
    BUG_REPORTS: "https://support.mem.ai/request-support/",
    SHARE_FEEDBACK: "https://support.mem.ai/share-feedback-form",
    REQUEST_SUPPORT: "https://support.mem.ai/article/7-request-support",
    REDIRECT: "https://get.mem.ai/redirect",
    IOS_APP_V2: "https://get.mem.ai/download",
    IOS_APP_GUIDE: "https://get.mem.ai/download",
    IOS_APP_ONBOARDING: "https://mem.onelink.me/MD4M/biplqi7c?utm_source=web_onboarding",
    MAC_APP: "https://get.mem.ai/download",
    MAC_APP_ONBOARDING: "https://get.mem.ai/download/mac?utm_source=web_onboarding",
    WINDOWS_APP: "https://get.mem.ai/download",
    WINDOWS_APP_ONBOARDING: "https://get.mem.ai/download/windows?utm_source=web_onboarding",
    CHROME_EXTENSION:
      "https://chromewebstore.google.com/detail/mem/kgfnifoledgeaphonbpbpfaepckpdgkg",
    MCP_CLAUDE_CONNECT: "https://claude.ai/directory/fab5214d-eb35-4038-8271-2a0be421a086",
    MCP_CHATGPT_CONNECT: "https://chatgpt.com/apps/mem/asdk_app_699f3c9f85788191874d8a0a43d5bca3",
    MCP_DOCS: "https://docs.mem.ai/mcp/overview",
    MEM_AGENT_DOCS: "https://get.mem.ai/features/agent",
    FAQ_VOICE_MODE: "https://help.mem.ai/features/voice-mode",
    FAQ_VOICE_MODE_NOT_SUPPORTED:
      "https://help.mem.ai/features/voice-mode#why-does-it-say-that-my-device-is-not-supported%3F",
    // Currently just the same link as the voice mode FAQ
    FAQ_MEETING_NOTIFICATIONS_NOT_SUPPORTED:
      "https://help.mem.ai/features/voice-mode#why-does-it-say-that-my-device-is-not-supported%3F",
  },
};
